import React, { useState } from "react";
import { AppSearchBox } from "@/components/main/search/AppSearchBox";
import { useOrgContextStore } from "@/components/main/stores/orgContextStore";

/** The Overview hero: always-expanded cross-entity search at hero scale.
 *  ⌘K still focuses it (useCommandK) — the affordance just stays quiet. */
export const HeroSearch: React.FC<{
  inputRef: React.Ref<HTMLInputElement>;
}> = ({ inputRef }) => {
  const [value, setValue] = useState("");
  // Search spans the org even when the lists below are narrowed to a space.
  const narrowed = useOrgContextStore((s) => s.selectedSpaceId !== null);

  return (
    <AppSearchBox
      value={value}
      onChange={setValue}
      placeholder={
        narrowed
          ? "Search models and tables in all spaces…"
          : "Search models, tables…"
      }
      alwaysExpanded
      size="lg"
      inputRef={inputRef}
    />
  );
};
